import * as Yup from 'yup';
import 'yup-phone';

export const ValidationSchemaAgentThirdParty = () =>
  Yup.object().shape({
    phone: Yup.string().length(10).required('Required'),
    address: Yup.object().nullable(true),
    suiteUnit: Yup.string().nullable(true),
  });
